import type { TailwindCssColor } from '@salescore/client-base'
import type { ViewQueryList } from '@salescore/core'
import { Array, pipe, Record } from 'effect'

const columnColors: TailwindCssColor[] = [`blue`, `green`, `yellow`, `red`, `purple`, `sky`, `emerald`, `amber`, `rose`]

/**
 * クエリのフィールドから使用されているノード名を抽出し、各ノードに色を割り当てます。
 * 同じノード名には同じ色が割り当てられ、色は循環的に使用されます。
 *
 * @param viewQueryList - ビュークエリリスト
 * @returns ノード名をキー、Tailwind CSSの色を値とするレコード
 */
export const buildNamesWithColors = (viewQueryList: ViewQueryList): Record<string, TailwindCssColor | undefined> =>
  Record.fromEntries(
    pipe(
      Array.dedupe(viewQueryList.fields.flatMap((x) => x.nodePath)),
      Array.map((nodeName, index) => [nodeName, columnColors[index % columnColors.length]]),
    ),
  )
